import React, { useRef } from "react";
import { useAppContext } from "@/context/Context";
import FeatureList from "../FeatureList/FeatureList";

function VideoSection() {
  const scrollRef = useRef(null);
  const { isLightTheme, toggleTheme } = useAppContext(); // isLightTheme is available here!

  const videos = [
    { src: "https://youtu.be/Mv9OSom7FI4", title: "Big Buck Bunny 1" },
    { src: "https://youtu.be/Mv9OSom7FI4", title: "Big Buck Bunny 2" },
    { src: "https://youtu.be/Mv9OSom7FI4", title: "Big Buck Bunny 3" },
    { src: "https://youtu.be/Mv9OSom7FI4", title: "Big Buck Bunny 4" },
  ];

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 320;
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  const extractYouTubeID = (url) => {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[2].length === 11 ? match[2] : null;
  };

  // --- Theme-dependent styles ---
  const sectionBgImage = isLightTheme
    ? "url(/MainHome/videoback.png)" // Light theme background
    : "url(/MainHome/videoback-dark.png)"; // Assuming you have a dark theme specific background
  // If not, you might use a dark color or pattern

  const titleColor = isLightTheme
    ? "#6f42c1" // Light theme title color (purple)
    : "#A06DFF"; // Dark theme title color (lighter purple, or white)

  const featureDescriptionColor = isLightTheme
    ? "inherit" // Inherit from parent (usually dark text on light bg)
    : "var(--rbt-color-body)"; // A variable for light text in dark mode (e.g., a light gray)

  const buttonBgColor = isLightTheme
    ? "#E6D8FF" // Light theme button background
    : "#3E2E6B"; // Dark theme button background (darker purple)

  const buttonShadow = isLightTheme
    ? "0 2px 6px rgba(111, 66, 193, 0.4)" // Light theme shadow
    : "0 2px 6px rgba(0, 0, 0, 0.6)"; // Dark theme shadow (darker for contrast)

  const buttonBorderColor = isLightTheme
    ? "rgba(111, 66, 193, 0.2)" // Subtle border for light theme
    : "rgba(255, 255, 255, 0.2)"; // Lighter border for dark theme

  const videoCardBg = isLightTheme
    ? "bg-white" // Light theme card background
    : "bg-dark"; // Dark theme card background

  const videoCardShadow = isLightTheme
    ? "shadow" // Default shadow for light theme
    : "shadow-lg"; // Stronger shadow for dark theme (or a custom dark shadow class)

  return (
    <>
      <FeatureList />
      <div
        className="container pt-5 pb-3"
        style={{
          marginTop: "30px",
          backgroundImage: sectionBgImage, // Apply dynamic background image
          backgroundSize: "cover",
          backgroundPosition: "center", // Ensure image covers well
          maxWidth: "100%",
          color: isLightTheme ? "inherit" : "var(--rbt-color-body)", // Ensure general text color adapts
        }}
      >
        {/* Section Title & Description */}
        <div className="row justify-content-center mb-5">
          <div
            className="col-12 text-center mb-4"
            style={{
              maxWidth: "900px",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            <h2
              className="fw-bold title"
              style={{
                color: titleColor, // Apply dynamic title color
                fontSize: "3rem",
                marginBottom: "25px",
              }}
            >
              What is Emdeon E-Portal and how does it help in learning?
            </h2>
            <p
              className="feature-description"
              style={{ color: featureDescriptionColor }} // Apply dynamic description color
            >
              Emdeon E-Portal is an intelligent and interactive learning portal
              meant to provide education with accessibility, fun, and efficiency
              for students, educators, and institutions. It has a simple-to-use
              interface and robust features, making online learning easy by
              consolidating tutorials, learning material, homework, and tests
              into one easy-to-use portal.
              <br />
              <br />
              Whether you are a student seeking instructor-led tutorials, a
              teacher juggling classes and materials, or an institute seeking to
              computerize learning, Emdeon E-Portal has got you covered.
            </p>
          </div>
        </div>

        <div className="row mb-4">
          <div className="col-12 text-center" style={{ marginTop: "100px" }}>
            <h2 className="title" style={{ color: titleColor }}>
              Featured Videos
            </h2>{" "}
            {/* Apply dynamic title color */}
          </div>
        </div>

        <div
          className="position-relative d-flex justify-content-center"
          style={{ maxWidth: "800px", margin: "0 auto", marginTop: "50px" }}
        >
          <div
            ref={scrollRef}
            className="d-flex gap-4 overflow-auto pb-3 px-5"
            style={{
              scrollBehavior: "smooth",
              width: "800px",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
            }}
          >
            {videos.map((video, idx) => {
              const videoId = extractYouTubeID(video.src);
              return (
                <div
                  key={idx}
                  className={`${videoCardBg} rounded ${videoCardShadow} p-2 flex-shrink-0`} // Apply dynamic card background and shadow
                  style={{ width: 300, height: 170 }}
                >
                  {videoId ? (
                    <iframe
                      width="300"
                      height="170"
                      src={`https://www.youtube.com/embed/${videoId}`}
                      title={video.title}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      className="rounded"
                    />
                  ) : (
                    <p style={{ color: featureDescriptionColor }}>
                      Invalid video URL
                    </p> // Ensure error message text adapts
                  )}
                </div>
              );
            })}
          </div>

          <button
            type="button"
            className="btn position-absolute top-50 translate-middle-y"
            style={{
              zIndex: 10,
              backgroundColor: buttonBgColor, // Apply dynamic button background
              border: `1px solid ${buttonBorderColor}`, // Apply dynamic button border
              left: "-50px",
              padding: 10,
              boxShadow: buttonShadow, // Apply dynamic button shadow
              color: isLightTheme ? "inherit" : "white", // Ensure arrow color adapts
            }}
            onClick={() => scroll("left")}
          >
            &lt;
          </button>

          <button
            type="button"
            className="btn position-absolute top-50 translate-middle-y"
            style={{
              zIndex: 10,
              backgroundColor: buttonBgColor, // Apply dynamic button background
              border: `1px solid ${buttonBorderColor}`, // Apply dynamic button border
              right: "-50px",
              padding: 10,
              boxShadow: buttonShadow, // Apply dynamic button shadow
              color: isLightTheme ? "inherit" : "white", // Ensure arrow color adapts
            }}
            onClick={() => scroll("right")}
          >
            &gt;
          </button>
        </div>
      </div>
    </>
  );
}

export default VideoSection;
